module.exports = __webpack_public_path__ + "static/img/logo-enviosweb-blanco.0234d59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-enviosweb-blanco.png
// module id = gCeo
// module chunks = 1